import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

type RowActionItem = {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
    disabled?: boolean;
};

interface RowActionsMenuProps {
    items: RowActionItem[];
}

const RowActionsMenu: React.FC<RowActionsMenuProps> = ({ items }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                size="small"
                aria-label="Aktionen"
                onClick={(event) => {
                    event.stopPropagation();
                    setAnchorEl(event.currentTarget);
                }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {items.map((item) => (
                    <MenuItem
                        key={item.label}
                        disabled={item.disabled}
                        onClick={(event) => {
                            event.stopPropagation();
                            handleClose();
                            item.onClick();
                        }}
                    >
                        {item.icon ? <ListItemIcon>{item.icon}</ListItemIcon> : null}
                        <ListItemText>{item.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default RowActionsMenu;
